import { BadForm, OkForm, BetterForm } from "../../../../content/blog/improving-accessibility-of-forms/components.jsx";
import * as React from 'react';
export default {
  BadForm,
  OkForm,
  BetterForm,
  React
};